<template>
  <div>     
    <v-container grid-list-md fluid>
      <v-layout align-center justify-space-around wrap>
        <v-flex md12>
          <v-card>
            <v-card-title>AuthKey</v-card-title>
            <v-card-text v-if="error">
                {{ error }}
            </v-card-text>
            <v-card-text v-else-if="encryptedAES">
              <div>Copy and paste the following</div>
              <p />
              <div>
                {{ encryptedAES }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import auth from "@/auth/authService";

export default {
  data() {
    return {
      challenge: this.$route.params.challenge,
      encryptedAES: null,
      error: null
    }
  },
  computed: {
  },
  components: {
  },
  created() {
    if (!this.challenge) {
      this.error = "Challenge required";
      return;
    }
    if (this.challenge && this.challenge.length != 16) {
      this.error = "Invalid challenge size"
      return;
    }
    auth.getAccessToken().then(accessToken => {
      this.encryptedAES = this.CryptoJS.AES.encrypt(accessToken, this.challenge).toString();
    });
  },
  methods: {
  }
}
</script>
